<template>
  <div class="wrapper">
    <v-layout>
      <v-flex class="input-label" xs2>案件選択（必須）</v-flex>
      <v-flex class="input-selector" xs10>
        <AppTwoColumnsSelectorWithFilteringAndSelectAll
          @search="search"
          @setIds="setInsertionOrderIds"
          :items="form.insertionOrderList"
          :addedIdAndNameList="form.query.insertionOrderAddedList"
          :useSearch="true"
          left-label="案件一覧"
          right-label="対象案件一覧"
          item-name="案件"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'IntervalReportModalAddTargetInsertionOrder',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    insertionOrderAddedList: {
      get() {
        return this.form.query.insertionOrderAddedList
      },
      set(idAndNameList) {
        this.form.query.insertionOrderAddedList = idAndNameList
      },
    },
  },
  methods: {
    search(keyword) {
      this.form.fetchInsertionOrderList(keyword)
    },
    setInsertionOrderIds(itemList) {
      this.insertionOrderAddedList = itemList.map(item => {
        return {
          id: item.id,
          name: item.name,
        }
      })
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.input-label {
  padding-top: 20px;
  color: #616161 !important;
  caret-color: #616161 !important;
}
.input-selector {
  padding-top: 20px;
}
</style>
